import {DatePipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';
import {SubscriptionAppService} from 'src/app/services/subscription-app.service';

@Component({
  selector: 'app-add-user-in-subscribed-soln',
  template: `
    <div class="mu-head" mat-dialog-title>
      <div class="mu-t">Manage users</div>
      <div class="mu-s">
        Invite teammates to {{ data?.solution_name | textpretty | titlecase }}
      </div>
    </div>

    <div class="mu-body" mat-dialog-content>
      <form class="mu-form" [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div class="mu-row">
          <div class="fld">
            <label>Email</label>
            <mat-form-field class="box-field" appearance="fill">
              <input
                type="email"
                matInput
                required
                formControlName="email"
                placeholder="name@company.com"
              />
            </mat-form-field>
            <div
              class="err"
              *ngIf="
                userForm.get('email').errors?.required &&
                userForm.get('email').touched
              "
            >
              Email is required
            </div>
          </div>

          <div class="fld">
            <label>Roles</label>
            <mat-form-field class="box-field" appearance="fill">
              <mat-select formControlName="roles" multiple placeholder="Select roles">
                <mat-option [value]="role" *ngFor="let role of availableRoles">{{
                  role | textpretty | titlecase
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <button type="submit" class="btn-primary" [disabled]="userForm.invalid">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                 stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Add user
          </button>
        </div>
      </form>

      <div class="mu-existing">
        <div class="mu-lbl">People with access</div>
        <div class="mu-empty" *ngIf="!existingUser?.length">No users added yet.</div>
        <div class="user-row" *ngFor="let user of existingUser">
          <span class="uav">{{ (user.email || '?').charAt(0) | uppercase }}</span>
          <div class="u-mid">
            <div
              class="u-email"
              [matTooltip]="user.email.length > 36 ? user.email : ''"
            >
              {{ user.email | namingsize : 36 }}
            </div>
            <div class="u-meta">
              Added {{ user['created_dtm'] | date : 'dd MMM yyyy' }}
            </div>
          </div>
          <button
            class="iconbtn danger"
            matTooltip="Remove user"
            (click)="deleteUser(user?.id)"
          >
            <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
                 stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M6 6l1 14h10l1-14" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="mu-foot" mat-dialog-actions align="end">
      <button class="btn-ghost" [mat-dialog-close]="false">Close</button>
    </div>
  `,
  styleUrls: ['./add-user-in-subscribed-soln.component.scss'],
})
export class AddUserInSubscribedSolnComponent implements OnInit {
  userForm: FormGroup | any;
  existingUser: any;
  availableRoles = ['sales_rep', 'customer_consultant'];

  constructor(
    public dialogRef: MatDialogRef<AddUserInSubscribedSolnComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private subscriptionService: SubscriptionAppService,
    private snackBar: SharedFeaturesService,
    private datePipe: DatePipe
  ) {
  }

  ngOnInit(): void {
    this.createForm();
    this.getExistingUser();
  }

  getExistingUser() {
    this.subscriptionService
      .getUsersSubscription(this.data?.subscription_id)
      .subscribe({
        next: (response: any) => {
          this.existingUser = response?.msg;
        },
        error: (error: any) => {
          console.error('an error occurred', error);
        },
      });
  }

  createForm() {
    this.userForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      roles: [''],
    });
  }

  deleteUser(id: string) {
    this.subscriptionService.deleteUsersSubscription(id).subscribe({
      next: (response: any) => {
        this.snackBar.openSnackBar(
          response['msg'],
          'Close',
          'success-snackbar'
        );
        this.getExistingUser();
      },
      error: (error: any) => {
        this.snackBar.openSnackBar(
          error?.['msg'] || 'Could not remove the user. Please try again.',
          'Close',
          'error-snackbar'
        );
      },
    });
  }

  onSubmit() {
    if (this.userForm.valid) {
      let formData = this.userForm.value;
      formData['subscription_id'] = this.data?.subscription_id;
      if (formData.roles == '') {
        formData.roles = ['sales_rep'];
      }
      this.subscriptionService.addUsersSubscription(formData).subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            response['msg'],
            'Close',
            'success-snackbar'
          );
          this.getExistingUser();
        },
        error: (error: any) => {
          this.snackBar.openSnackBar(
            error?.msg || error.message || error?.error.msg,
            'Close',
            'error-snackbar'
          );
        },
      });
    } else {
      this.userForm.markAllAsTouched();
    }
  }
}
